export default "__VITE_ASSET__qGRy0yZK__"